import React from 'react'
import Button from "../../component/Button/Button";
import Modal from "react-bootstrap/Modal";
import {Col, Form, Row} from "react-bootstrap";
import {faTrash, faXmarkCircle} from "@fortawesome/free-solid-svg-icons";

class DeleteBucketModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            confirmName: '',
            dataDeleteConfirmed: false,
            errorMessage: '',
        };
        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleConfirmNameChange = this.handleConfirmNameChange.bind(this);
        this.handleDeleteConfirmChange = this.handleDeleteConfirmChange.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
    }

    handleShow() {
        this.setState({show: true, confirmName: '', dataDeleteConfirmed: false, errorMessage: ''});
    }

    handleClose() {
        this.setState({show: false, confirmName: '', dataDeleteConfirmed: false, errorMessage: ''});
    }

    handleConfirmNameChange(event) {
        this.setState({confirmName: event.target.value});
    }

    handleDeleteConfirmChange(event) {
        this.setState({dataDeleteConfirmed: event.target.checked});
    }

    handleDelete() {
        if (this.state.confirmName !== this.props.bucketName) {
            this.setState({errorMessage: `"${this.state.confirmName}" does not match the bucket name "${this.props.bucketName}"`});
            return;
        }

        if (this.props.hasObjects && !this.state.dataDeleteConfirmed) {
            this.setState({errorMessage: "Please confirm that you want to delete all the data with the bucket"});
            return;
        }

        this.props.delete();
    }

    render() {
        const { bucketName, hasObjects } = this.props;
        const { show, confirmName, dataDeleteConfirmed, errorMessage } = this.state;
        const isConfirmValid = confirmName === bucketName && (!hasObjects || dataDeleteConfirmed);

        return <>
            <Button className="secondary-outline btn btn-md" faIcon={faTrash} label="Delete" onClick={this.handleShow}/>

            <Modal show={show} onHide={this.handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Permanently delete bucket</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Are you sure you want to delete bucket: <strong>{bucketName}</strong>?</p>
                    <p>This will permanently delete the bucket and all its contents.</p>
                    <p>To confirm, type the bucket name below:</p>
                    <Form.Control
                        type="text"
                        placeholder={bucketName}
                        value={confirmName}
                        onChange={this.handleConfirmNameChange}
                    />
                    {hasObjects && (
                        <Form.Group as={Row} className="mt-3">
                            <Col sm="1">
                                <Form.Check
                                    type="checkbox"
                                    checked={dataDeleteConfirmed}
                                    onChange={this.handleDeleteConfirmChange}
                                />
                            </Col>
                            <Form.Label column sm="11">
                                This bucket is not empty. I confirm I want to delete the bucket with all the data inside.
                            </Form.Label>
                        </Form.Group>
                    )}
                    {errorMessage && <p className="text-danger mt-2">{errorMessage}</p>}
                </Modal.Body>
                <Modal.Footer>
                    <Button className="cancel-outline btn" faIcon={faXmarkCircle} label="Cancel" onClick={this.handleClose}/>
                    <Button
                        className="secondary btn"
                        faIcon={faTrash}
                        label="Delete"
                        onClick={this.handleDelete}
                        disabled={!isConfirmValid}
                    />
                </Modal.Footer>
            </Modal>
        </>
    }
}

export default DeleteBucketModal
